import { api } from "./api";

export async function getAllServices() {
    try {
        const response = await api.get("services?limit=500", {
            withCredentials: true,
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        return { error: (error as Error).message };
    }
}
